export interface ISnHeatmapResponse<Model> {
  heatmap: Model[];
}
